import React from "react";
import { Box, Container, Typography } from "@mui/material";

const HomeVisitInjections = () => {
  return (
    <Box sx={{ py: 4 }}>
      <Container maxWidth="md">
        <Typography variant="h4" gutterBottom color="primary.main">
          Home Visit & Injections
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          At VEM Plus Urgent Care, we understand that traveling for medical attention isn't always possible. 
          Our <strong>Home Visit & Injection</strong> services bring essential healthcare directly to your doorstep 
          ensuring comfort, safety, and professional care.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Services Offered at Home:
        </Typography>
      <Typography variant="body2"component="ul"gutterBottom sx={{ pl: 3, listStyleType: 'disc', marginBottom: '0.5rem' }}>
          <li>Doctor home visits for non-critical conditions</li>
          <li>Nursing visits for injections and wound care</li>
          <li>IV/IM/SC injections as prescribed by physicians</li>
          <li>Blood pressure and blood sugar monitoring</li>
        </Typography>

        <Typography variant="h6" gutterBottom>
          Why Choose Us?
        </Typography>
         <Typography variant="body2"component="ul"gutterBottom sx={{ pl: 3, listStyleType: 'disc', marginBottom: '0.5rem' }}>
          <li>Experienced medical professionals at your service</li>
          <li>Time-saving and convenient for elderly or immobile patients</li>
          <li>Strict hygiene and safety standards followed</li>
          <li>Affordable and transparent pricing</li>
        </Typography>

        <Typography variant="body1" sx={{ mt: 2 }}>
          To schedule a home visit or injection service, contact us today. 
          We are here to make healthcare easier and more accessible for you.
        </Typography>
      </Container>
    </Box>
  );
};

export default HomeVisitInjections;

